if (!window.EcoScentAttributionTracking) {
  window.EcoScentAttributionTracking = {
    storageKey: 'ecoscent_attribution',
    expiryDays: 90,
    trackingKeys: ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'],

    readStoredAttribution: function () {
      const namespace = window.EcoScentAttributionTracking;

      try {
        const stored = JSON.parse(localStorage.getItem(namespace.storageKey) || '{}');

        if (stored.expires_at && Date.now() > stored.expires_at) {
          localStorage.removeItem(namespace.storageKey);
          return {};
        }

        return stored;
      } catch (error) {
        return {};
      }
    },

    saveAttribution: function (attribution) {
      try {
        localStorage.setItem(window.EcoScentAttributionTracking.storageKey, JSON.stringify(attribution));
      } catch (error) {
        return;
      }
    },

    captureAttribution: function () {
      const namespace = window.EcoScentAttributionTracking;
      const urlParameters = new URLSearchParams(window.location.search);
      const attribution = namespace.readStoredAttribution();

      if (!attribution.first_landing_page) {
        attribution.first_landing_page = window.location.href;
      }

      if (!attribution.referrer && document.referrer) {
        attribution.referrer = document.referrer;
      }

      const urlCarriesTracking = namespace.trackingKeys.some(function (key) {
        return urlParameters.has(key) && urlParameters.get(key);
      });

      if (urlCarriesTracking) {
        namespace.trackingKeys.forEach(function (key) {
          attribution[key] = urlParameters.get(key) || '';
        });

        attribution.landing_page = window.location.href;
        attribution.captured_at = new Date().toISOString();
      }

      attribution.expires_at = Date.now() + namespace.expiryDays * 24 * 60 * 60 * 1000;

      namespace.saveAttribution(attribution);
    },
  };

  window.EcoScentAttributionTracking.captureAttribution();
}
